import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  id,
  className = '',
  ...props
}: TextareaProps) {
  const textareaId = id || label.toLowerCase().replace(/\s+/g, '-');
  return <div className={`flex flex-col ${className}`} data-id="element-16">
      <label htmlFor={textareaId} className="mb-2 text-xs font-medium tracking-widest text-gray-500 uppercase" data-id="element-17">
        {label}
      </label>
      <textarea id={textareaId} className={`px-4 py-3 bg-transparent border ${error ? 'border-red-500' : 'border-gray-300'} focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-none placeholder:text-gray-400 resize-y min-h-[120px]`} {...props} data-id="element-18" />
      {error && <span className="mt-1 text-xs text-red-500" data-id="element-19">{error}</span>}
    </div>;
}